/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";
import { Link } from "react-router-dom";

import moment from "moment";

export const getOrderColumns = label => [
  {
    id: "orderNumber",
    Header: "#",
    accessor: "OrderNumber",
    Cell: ({ cell, row }) => (
      <Link to={`/dispatch/orders/${row.original.RecId}/summary`}>
        #{cell.value}
      </Link>
    )
  },
  {
    Header: "Trip",
    accessor: "Trip"
  },
  {
    Header: "Leg",
    id: "leg",
    accessor: "Leg"
  },
  {
    id: "startLocation",
    Header: label === "Untripped" ? "Pickup Location" : "Start Location",
    accessor: "StartLocation",
    Cell: ({ cell }) =>
      `${cell.value.LocationID}-${cell.value.LocationName}/${cell.value.City}, ${cell.value.State}`
  },
  {
    id: "pickupDate",
    Header: "DATE/TIME",
    accessor: "PickupDate",
    Cell: ({ cell }) => moment(cell.value).format("MM/DD/YY HH:mm")
  },
  {
    Header: "LOAD",
    accessor: "Route.LoadTime"
  },
  {
    Header: "Travel",
    accessor: "Route.TravelTime"
  },

  {
    Header: "End Location",
    accessor: "EndLocation",
    Cell: ({ cell }) =>
      `${cell.value.LocationID}-${cell.value.LocationName}/${cell.value.City}, ${cell.value.State}`
  },
  {
    Header: "ARRIVAL DATE/TIME",
    accessor: "ArrivalDate",
    Cell: ({ cell }) => moment(cell.value).format("MM/DD/YY HH:mm")
  },
  {
    Header: "Unload",
    accessor: "Route.UnloadTime"
  },
  {
    Header: "Travel",
    accessor: "TravelTime"
  },
  {
    id: "nextAvailable",
    Header: "Next Available",
    Cell: ({ row }) =>
      row.original.showNextAvailable
        ? moment(row.original.ArrivalDate)
            .add(
              row.original.Route.UnloadTime + row.original.TravelTime,
              "hours"
            )
            .format("MM/DD/YY HH:mm")
        : ""
  }
];

export const LEG_ZERO_COLUMNS = [
  {
    id: "orderNumber",
    Header: "#",
    accessor: "OrderNumber"
  },
  {
    Header: "TR",
    accessor: "Trip"
  },
  {
    Header: "LG",
    id: "leg",
    accessor: "Leg"
  },
  {
    Header: "Start Location",
    accessor: "Route.StartLocation",
    Cell: ({ cell }) =>
      `${cell.value.LocationID}-${cell.value.LocationName}/${cell.value.City}`
  },
  {
    Header: "START DATE/TIME",
    accessor: "StartTime",
    Cell: ({ cell }) => moment(cell.value).format("MM/DD/YY HH:mm")
  },
  {
    Header: "TRVL",
    accessor: "Route.TravelTime"
  },
  {
    Header: "Pickup Location",
    accessor: "Route.PickupLocation",
    Cell: ({ cell }) =>
      `${cell.value.LocationID}-${cell.value.LocationName}/${cell.value.City}`
  },

  {
    Header: "ARRIVAL DATE/TIME",
    accessor: "PickupDate",
    Cell: ({ cell }) => moment(cell.value).format("MM/DD/YY HH:mm")
  }
];

export const LAST_LEG_COLUMNS = [
  {
    id: "orderNumber",
    Header: "#",
    accessor: "OrderNumber"
  },
  {
    Header: "TR",
    accessor: "Trip"
  },
  {
    Header: "LG",
    id: "leg",
    accessor: "Leg"
  },
  {
    Header: "Delivery Location",
    accessor: "Route.DeliveryLocation",
    Cell: ({ cell }) =>
      `${cell.value.LocationID}-${cell.value.LocationName}/${cell.value.City}`
  },
  {
    Header: "START DATE/TIME",
    accessor: "StartTime",
    Cell: ({ cell }) => moment(cell.value).format("MM/DD/YY HH:mm")
  },
  {
    Header: "TRVL",
    accessor: "Route.TravelTime"
  },
  {
    Header: "Ending Location",
    accessor: "Route.EndingLocation",
    Cell: ({ cell }) =>
      `${cell.value.LocationID}-${cell.value.LocationName}/${cell.value.City}`
  },
  {
    Header: "ARRIVAL DATE/TIME",
    Cell: ({ row }) =>
      moment(row.original.StartTime)
        .add(row.original.Route.TravelTime, "hours")
        .format("MM/DD/YY HH:mm")
  }
];
